import { createContext, useContext } from "react";

export type TChatAppearance = "default" | "leo";

const ChatAppearanceContext = createContext<TChatAppearance>("default");

export const ChatAppearanceProvider = ChatAppearanceContext.Provider;

export const useChatAppearance = () => useContext(ChatAppearanceContext);
